import Vue from "vue"
import DropdownDatepicker from "vue-dropdown-datepicker"

Vue.component("DropdownDatepicker", DropdownDatepicker)
